var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    {
      ref: "shotsTableRef",
      staticClass: "pa-0 overflow-visible",
      attrs: { id: "shots-table-id", fluid: "" },
    },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              staticClass: "d-flex flex-column align-start py-0",
              attrs: { cols: "12" },
            },
            [
              _c("v-data-table", {
                staticClass: "elevation-0 w-100",
                attrs: {
                  headers: _vm.headers,
                  items: _vm.shots,
                  dense: "",
                  "mobile-breakpoint": "0",
                  "calculate-widths": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.player",
                    fn: function ({ item }) {
                      return [
                        _c("div", { staticClass: "d-flex align-center" }, [
                          _c(
                            "span",
                            { staticClass: "body-2" },
                            [
                              _c(
                                "router-link",
                                { attrs: { to: "/player/" + item.playerId } },
                                [_vm._v(_vm._s(item.player))]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "item.playerFromName",
                    fn: function ({ item }) {
                      return [
                        _c("div", { staticClass: "d-flex align-center" }, [
                          _c(
                            "span",
                            { staticClass: "body-2" },
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: { to: "/player/" + item.playerFromId },
                                },
                                [_vm._v(_vm._s(item.playerFromName))]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "item.teamName",
                    fn: function ({ item }) {
                      return [
                        _c("div", { staticClass: "d-flex align-center" }, [
                          _c("img", {
                            staticClass: "mr-2",
                            staticStyle: { height: "22px", width: "22px" },
                            attrs: {
                              src:
                                "https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/" +
                                item.teamId +
                                ".png",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "body-2" },
                            [
                              _c(
                                "router-link",
                                { attrs: { to: "/team/" + item.teamId } },
                                [_vm._v(_vm._s(item.teamName))]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "item.min",
                    fn: function ({ item }) {
                      return [
                        _c("div", { staticClass: "d-flex align-center" }, [
                          _c("span", { staticClass: "body-2" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(item.min) +
                                ":" +
                                _vm._s(
                                  item.sec > 9 ? item.sec : `0${item.sec}`
                                ) +
                                "\n            "
                            ),
                          ]),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "item.typeLabel",
                    fn: function ({ item }) {
                      return [
                        _c("div", { staticClass: "d-flex align-center" }, [
                          _c(
                            "span",
                            { staticClass: "body-2" },
                            [
                              item.eventTypeId === 16
                                ? _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-1",
                                      attrs: { small: "" },
                                    },
                                    [_vm._v("sports_soccer")]
                                  )
                                : _vm._e(),
                              _vm._v(
                                "\n              " +
                                  _vm._s(item.typeLabel) +
                                  "\n              "
                              ),
                              item.ownGoal
                                ? _c("span", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("team.trendsTab.ownGoals")
                                        )
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              item.penaltyGoal
                                ? _c("span", [
                                    _vm._v(
                                      " - " +
                                        _vm._s(
                                          _vm.$t(
                                            "videoHighlights.qualifierIds.9"
                                          )
                                        )
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("span"),
                            ],
                            1
                          ),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "item.xG",
                    fn: function ({ item }) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex align-center w-100 h-100 justify-center",
                            style: {
                              "background-color": _vm.getBackgroundColor(
                                item,
                                "xG"
                              ),
                            },
                          },
                          [
                            _c("span", { staticClass: "body-2" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(item.xG.toFixed(2)) +
                                  "\n            "
                              ),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }